// Configuración API Lumen
// Detecta automáticamente si estás en desarrollo o producción
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' 
    ? 'http://localhost:8000/api'
    : `${window.location.origin}/api`);

export const API_ENDPOINTS = {
  // Autenticación
  login: `${API_BASE_URL}/login`,
  logout: `${API_BASE_URL}/logout`,
  registro: `${API_BASE_URL}/registro`,
  userLogued: `${API_BASE_URL}/userLogued`,
  estado: `${API_BASE_URL}/estado`,
  
  // Usuarios
  usuarios: `${API_BASE_URL}/usuarios`,
  
  // Categorías
  categorias: `${API_BASE_URL}/categorias`,
  categoriasOrden: `${API_BASE_URL}/categorias/orden`,
  
  // Subcategorías
  subcategorias: `${API_BASE_URL}/subcategorias`,
  
  // Servicios
  servicios: `${API_BASE_URL}/servicios`,
  
  // Tiendas
  tiendas: `${API_BASE_URL}/tiendas`,
  
  // Banners
  banners: `${API_BASE_URL}/banners`,
  
  // Días
  dias: `${API_BASE_URL}/dias`,
  
  // Turnos
  turnos: `${API_BASE_URL}/turnos`,
};

export default API_BASE_URL;
